import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { bindActionCreators } from 'redux';

import { currentUserSelector, currentAccountSelector } from '../selectors/AuthSelector';
import { getAccountMessagesStatus } from '../selectors/AccountMessagesSelector';
import * as MessagesActions from '../actions/MessagesActions';
import Immutable from 'immutable';
import AccountMessages from '../components/borrowing/accountmessages/AccountMessages';
import DocumentHeadContainer from './DocumentHeadContainer';
import BasePageContainer from './BasePageContainer';


export class MessagesContainer extends BasePageContainer {

  static fetchInitialData(params, query, store) {
    const account = currentAccountSelector(store.getState());
    const accountId = account && account.get('id');

    return [
      store.dispatch(MessagesActions.fetchMessages({ accountId }))
    ];
  }

  static getBackToTitleKey() {
    return 'messages';
  }

  componentDidMount() {
    super.componentDidMount();

    const { accountId } = this.props;
    this.props.messageActions.fetchMessages({ accountId });
  }

  render() {
    const pageTitle = this.props.intl.formatMessage({ id: 'section_title_messages' });

    return (
      <div>
        <DocumentHeadContainer pageTitle={pageTitle} />
        <AccountMessages {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const user = currentUserSelector(state);
  const messages = state.getIn(['entities', 'messages'], Immutable.Map());
  const accountMessagesStatus = getAccountMessagesStatus(state);
  const account = currentAccountSelector(state);
  const accountId = account.get('id');

  return {
    user,
    messages,
    fetching: accountMessagesStatus.get('fetching', false),
    accountId
  };
};

const mapDispatchToProps = dispatch => ({
  messageActions: bindActionCreators(MessagesActions, dispatch)
});

MessagesContainer.propTypes = {
  intl: intlShape,
  fetching: PropTypes.bool,
  messageActions: PropTypes.objectOf(PropTypes.func),
  accountId: PropTypes.number
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MessagesContainer));



// WEBPACK FOOTER //
// ./app/containers/MessagesContainer.jsx